import React from 'react';
import { Container, Typography, Box, Paper, Grid, Button } from '@mui/material';

const Quiz = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Quiz Registration
          </Typography>
          <Typography variant="body1" paragraph align="center" color="text.secondary">
            Participate in our exciting quiz competition! Scan the QR code below or click the link to register.
          </Typography>

          <Grid container spacing={3} justifyContent="center" sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img
                  src="/assets/Quiz QR Code.png"
                  alt="Quiz Registration QR Code"
                  style={{ maxWidth: '200px', height: 'auto', marginBottom: '16px' }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => window.open('https://forms.gle/g7piamwpSTk7DJJx5', '_blank')}
                  sx={{ py: 1.5 }}
                >
                  Register for Quiz
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
};

export default Quiz;

